import axios from 'axios';
import shortid from 'shortid';

import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ModuleType } from 'global-services/constants/OhsObject';
import { OhsApiRequestName, RequestType } from 'global-services/api/OhsApiModels';
import { getCurrentTimezone } from 'global-services/OhsDataParse';
// import addWatermarkToSignature from 'global-services/watermark/addWatermarkToSignature';

import { OhsSignature } from './OhsSignatureModels';

export const getSignatureList = async (payload: string[]): Promise<OhsSignature[]> => {
  const res: { items: { _ids: any[] } } | null = await OhsApiRequest(
    RequestType.Attachments,
    ModuleType.Attachment,
    OhsApiRequestName.List,
    { _ids: payload }
  );
  let attachmentList: any[] = [];

  if (res?.items) {
    // check if any attachment null or undefined
    attachmentList = (res.items._ids || []).filter((a) => a);
  }
  return attachmentList;
};

export const uploadPresignedSignature = async (
  file: File,
  url: string,
  onSuccess: (uploaded: any) => void,
  callback: () => void,
  uploadToken?: string
): Promise<void> => {
  try {
    const id = shortid.generate();
    const newValue = { id, details: '', url };

    const signedUrlRes: any = await OhsApiRequest(
      RequestType.Attachments,
      ModuleType.Attachment,
      uploadToken ? OhsApiRequestName.LinkAccessUploadUrl : OhsApiRequestName.UploadUrl,
      {
        fileName: `${file.name}.png`,
      },
      {
        linkAccessAttachmentsUploadHeader: uploadToken,
      }
    );

    if (!signedUrlRes?.key || !signedUrlRes?.url || !signedUrlRes?.bucket) {
      throw new Error('Failed to get presigned URL for signature upload.');
    }

    const { key, url: presignedUrl } = signedUrlRes;
    const uploadAxios = axios.create();

    await uploadAxios.put(presignedUrl, file, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    });

    const completeRes: any = await OhsApiRequest(
      RequestType.Attachments,
      ModuleType.Attachment,
      uploadToken
        ? OhsApiRequestName.LinkAccessUploadSinglepartComplete
        : OhsApiRequestName.UploadSinglepartComplete,
      {
        key,
        tzDateUploaded: getCurrentTimezone(),
      },
      {
        linkAccessAttachmentsUploadHeader: uploadToken,
      }
    );

    if (!completeRes?.key || !completeRes?.bucket) {
      throw new Error('Failed to finalize signature upload.');
    }

    newValue.details = JSON.stringify({
      ...completeRes,
      fileName: file.name,
    });
    onSuccess(newValue);
  } catch (err) {
    console.error('Signature upload error:', err);
    callback();
  }
};
